const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8003',
    // BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://yourplatform-backend.thankfultree-bbe94d76.ukwest.azurecontainerapps.io',
    API_V1: process.env.REACT_APP_API_V1_STR || '/api/v1',
    get API_URL() {
      return `${this.BASE_URL}${this.API_V1}`;
    }
  };
  
  export default API_CONFIG;
